import DomainManager from '../../shared/utils/DomainManager';

import { apiClient } from './apiClient';
import { NotificationItem, NotificationQuery } from '../../constants/notification';

export type NotificationListResponse = {
  last_page: boolean;
  notifications: NotificationItem[];
};

export const fetchNotifications = (data: NotificationQuery | null, targetEnv: string) => {
  const domainManager = new DomainManager(targetEnv);
  const defaultQuery = { except_community_notification: true };

  return apiClient.get<NotificationListResponse>(
    `${domainManager.getTravelerServiceDomain()}/notifications`,
    {
      params: data ? { ...data, ...defaultQuery } : defaultQuery,
    }
  );
};

export const markAsReadNotification = (id: string, targetEnv: string) => {
  const domainManager = new DomainManager(targetEnv);
  return apiClient.put(`${domainManager.getTravelerServiceDomain()}/notifications/${id}/read`);
};

export type HasFreshNotificationResponse = {
  new_exists: boolean;
};

export const fetchHasFreshNotification = (targetEnv: string) => {
  const domainManager = new DomainManager(targetEnv);

  return apiClient.get<HasFreshNotificationResponse>(
    `${domainManager.getTravelerServiceDomain()}/notifications/new_exists`,
    {
      params: { except_community_notification: true },
    }
  );
};
